<template>
    <v-content class="pa-0 text-center">


        <section class="about-section" id="hero">
            <v-container>
                <v-row class="text-center" no-gutters>
                    <v-flex class="hero-logo" md3 sm12 xs12>
                        <v-img class="cover-img" src="../../assets/firme/bg-logo.png"></v-img>
                    </v-flex>
                    <v-flex class="text-center justify-center d-flex flex-column align-center pa-5" md9 sm12 xs12>
                        <h1>Добро дошли на веб страницу београдских општинских кризних штабова</h1>
                        <h2>Ова страница је намењена особама којима је потребна помоћ или достава намирница и
                            лекова</h2>
                        <v-btn class="animated infinite pulse primarna" v-scroll-to="'#form'">
                            Кликни овде
                            <v-icon>keyboard_arrow_down</v-icon>
                        </v-btn>
                    </v-flex>
                </v-row>
            </v-container>
        </section>


        <section class="everyone-section" id="form">
            <v-container>
                <v-row no-gutters>
                    <v-flex md12 sm12 xs12>
                        <h1 class="text-center">УПУТСТВО ЗА ДОБИЈАЊЕ <span class="text-help">ПОМОЋИ</span></h1>
                        <h2 class="text-center mb-3">
                            Уколико имате више од 65 година или сте особа са оштећеним слухом и потребна Вам је помоћ у набавци хране, лекова и осталих ствари које су Вам тренутно неопходне молимо вас да испратите кораке испод:
                        </h2>

                        <div>
                            <v-row
                                align="center"
                                justify="center"
                            >
                                <v-col
                                    cols="12"
                                    md="8"
                                    sm="8">
                                    <v-row>
                                        <v-col cols="12" md="6" sm="12"
                                               class="first-step pt-0">

                                            <v-card-title class="headline"><span class="numberCircle">1</span> <span
                                                class="step-txt text-help">ПРВИ КОРАК</span></v-card-title>
                                        </v-col>

                                        <v-col cols="12" md="6" sm="12" class="first-step">

                                            <v-card-text class="">
                                                <v-select
                                                    :items="municipalities"
                                                    @change="$vuetify.goTo('#instructions')"
                                                    item-text="nameCyrillic"
                                                    item-value="id"
                                                    label="Општина"
                                                    placeholder="Изаберите Вашу општину"
                                                    v-model="municipalitiesSelected"
                                                ></v-select>
                                            </v-card-text>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </div>

                    </v-flex>


                </v-row>
            </v-container>
        </section>

        <section class="idea-section" id="instructions">
            <v-container v-if="municipalitiesSelected">
                <v-row
                    align="center"
                    justify="center"
                >
                    <v-col
                        cols="12"
                        md="8"
                        sm="8">
                        <v-row>
                            <v-col cols="12" md="12" sm="12">

                                <v-card-title class="headline"><span class="numberCircle">2</span> <span
                                    class="step-txt text-help">ДРУГИ КОРАК</span></v-card-title>
                            </v-col>

                            <v-col cols="12" md="12" sm="12">

                                <v-card-text class="phone-number" v-if="municipalitiesSelected !== ''">
                           
                                    <span v-for="number in phoneNumbers" :key="number.id">
                                        <p>{{number.p1.text}}</p>

                                        <span v-if="number.p2.text !== ''">
                                        <p >{{number.p2.text}}</p>
                                         <v-row class="text-center" v-for="phone in number.p2" :key="phone.id">

                                                <span class="w-full" v-if="phone.numbers">  
                                                    <span v-for="numbers in phone.numbers" :key="numbers.id">
                                                        <p v-if="phone.text">{{phone.text}}</p>
                                                    </span>
                                                </span>


                                                <v-col cols="12" :md="phone.numbers.length === 1 ? '12':'6'" sm="12" v-for="numbers in phone.numbers" :key="numbers.id">
                                                    <v-icon small>phone</v-icon>
                                                        <a :href="'tel:'+ numbers">
                                                            <b>{{ numbers }}</b>
                                                        </a>
                                                </v-col>
                                            </v-row>
                                            </span>
                                    </span>
                                    
                                    <p></p>
                                    <!-- <div  v-if="municipalitiesSelected == 16 || municipalitiesSelected == 17">
                                    <p>Mолимо вас да позовете Дневнe центре и клубове за најстарије суграђане града Београда на следеће бројеве телефоне:</p>
                                    <span class="pb-2" v-for="(otherPhone, index) in otherNumbers" :key="index">
                                            <p> {{index}}</p>
                                            <v-row class="pb-2" v-if="Array.isArray(otherPhone)">
                                                <v-col cols="12" md="6" sm="12" v-for="number in otherPhone" :key="number.id">
                                                    <v-icon small>phone</v-icon>
                                                        <a :href="'tel:'+ number">
                                                            <b>{{ number }}</b>
                                                        </a>
                                                </v-col>
                                            </v-row>
                                            <v-row v-else>
                                               <v-col cols="12" md="12" sm="12">
                                                    <v-icon small>phone</v-icon>
                                                        <a :href="'tel:'+ otherPhone">
                                                            <b> 011 / {{ otherPhone }}</b>
                                                        </a>
                                                </v-col>
                                            </v-row>
                                    </span>
                                    </div>
                                    <p>
                                        Молимо вас да позовете Општински кризни центар на следеће бројеве телефона:
                                    </p>
                                    <v-row class="pb-2 " v-if="phoneNumbers.length">
                                        <v-col :key="numb.id" cols="12" md="6" sm="12" v-for="numb in phoneNumbers"
                                               xl="4">
                                        <span class="pl-3">
                                            <v-icon small>phone</v-icon> <a :href="'tel:'+'011'+ numb"> <b>011 / {{numb}}</b></a>
                                        </span>
                                        </v-col>

                                    </v-row>
                                    <div v-if="municipalitiesSelected != 16 && municipalitiesSelected != 17">
                                    <span class="pb-2" v-for="(otherPhone, index) in otherNumbers" :key="index">
                                            <p> {{index}}</p>
                                            <v-row class="pb-2" v-if="Array.isArray(otherPhone)">
                                                <v-col cols="12" md="6" sm="12" v-for="number in otherPhone" :key="number.id">
                                                    <v-icon small>phone</v-icon>
                                                        <a :href="'tel:'+ number">
                                                            <b>{{ number }}</b>
                                                        </a>
                                                </v-col>
                                            </v-row>
                                            <v-row v-else>
                                               <v-col cols="12" md="12" sm="12">
                                                    <v-icon small>phone</v-icon>
                                                        <a :href="'tel:'+ otherPhone">
                                                            <b> 011 / {{ otherPhone }}</b>
                                                        </a>
                                                </v-col>
                                            </v-row>
                                    </span>
                                    </div> -->

                                    <p>
                                        Уколико нисте у могућности да затражите помоћ телефоном попуните захтев испод:
                                    </p>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn @click="popuniZahtev" color="primary" v-scroll-to="'#form2'">Попуни
                                            захтев
                                        </v-btn>
                                    </v-card-actions>
                                </v-card-text>
                                <v-card-text v-else>
                                    Молимо вас одаберите жељену локацију како би смо вам приказали жељене бројеве.
                                </v-card-text>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-container>
        </section>

        <section class="everyone-section" id="form2" v-if="showRequst">
            <v-container>
                <v-row no-gutters>
                    <v-flex md12 sm12 xs12>

                        <div>
                            <v-row
                                align="center"
                                justify="center"
                            >
                                <v-col
                                    cols="12"
                                    md="8"
                                    sm="8">
                                    <v-row>
                                        <v-col cols="12" md="12" sm="12">

                                            <v-card-title class="headline"><span class="numberCircle">3</span> <span
                                                class="step-txt text-help">ТРЕЋИ КОРАК</span></v-card-title>
                                        </v-col>

                                        <v-col cols="12" md="12" sm="12">

                                            <v-card class="elevation-2">
                                                <v-card-title class="headline">
                                                   3. Уколико нисте у могућности да затражите помоћ телефоном попуните захтев испод:
                                                </v-card-title>

                                                <v-form
                                                    @submit.prevent="makeNewRequest()"
                                                    ref="form"
                                                    v-model="valid"
                                                    lazy-validation
                                                    >

                                                <v-card-text class="pl-8 pr-8">

                                                    <v-row class="text-center">


                                                        <v-col cols="12" md="4" sm="12" xl="4">
                                                            <v-text-field
                                                                class="pb-1"
                                                                filled
                                                                label="Име"
                                                                placeholder="Лично име"
                                                                v-model="order.requesterFirstName"
                                                                :rules="[requiredRule]"
                                                                required
                                                            ></v-text-field>
                                                        </v-col>

                                                        <v-col cols="12" md="4" sm="12" xl="4">
                                                            <v-text-field
                                                                class="pb-1"
                                                                filled
                                                                label="Презиме"
                                                                placeholder="Лично презиме"
                                                                v-model="order.requesterLastName"
                                                                :rules="[requiredRule]"
                                                                required
                                                            ></v-text-field>
<!--                                                            <error-field :errors="errors" field="requesterLastName"
                                                                         v-if="errors.length"/>-->
                                                        </v-col>


                                                        <v-col cols="12" md="4" sm="12" xl="4">
                                                            <v-text-field
                                                                class="pb-1"
                                                                filled
                                                                type="text"
                                                                label="Телефон"
                                                                placeholder="Број телефона"
                                                                v-model="order.requesterPhoneNumber"
                                                                :rules="[requiredRule]"
                                                                required
                                                            ></v-text-field>
<!--                                                            <error-field :errors="errors" field="requesterPhoneNumber"
                                                                         v-if="errors.length"/>-->
                                                        </v-col>

                                                        <v-col cols="12" md="4" sm="12" xl="4">
                                                            <v-text-field
                                                                class="pb-1"
                                                                filled
                                                                label="Адреса"
                                                                placeholder="Унесите адресу"
                                                                type="text"
                                                                v-model="order.requesterAddress"
                                                                :rules="[requiredRule]"
                                                                required
                                                            ></v-text-field>
<!--                                                            <error-field :errors="errors" field="requesterAddress"
                                                                         v-if="errors.length"/>-->
                                                        </v-col>


                                                        <v-col cols="12" md="4" sm="12" xl="4">
                                                            <v-text-field
                                                                class="pb-1"
                                                                filled
                                                                label="Улаз"
                                                                placeholder="Улаз"
                                                                v-model="order.requesterHouseNumber"
                                                            ></v-text-field>
<!--                                                            <error-field :errors="errors" field="requesterHouseNumber"
                                                                         v-if="errors.length"/>-->
                                                        </v-col>

                                                        <v-col cols="12" md="4" sm="12" xl="4">
                                                            <v-text-field
                                                                class="pb-1"
                                                                filled
                                                                label="Број стана"
                                                                placeholder="Број стана"
                                                                v-model="order.requesterAppartmentNumber"
                                                            ></v-text-field>
<!--                                                            <error-field :errors="errors" field="requesterAppartmentNumber"
                                                                         v-if="errors.length"/>-->
                                                        </v-col>

                                                        <v-col cols="12" md="4" sm="12" xl="4">
                                                            <v-text-field
                                                                class="pb-1"
                                                                filled
                                                                label="Интерфон"
                                                                placeholder="Интерфона"
                                                                v-model="order.intercom"
                                                            ></v-text-field>
<!--                                                            <error-field :errors="errors" field="intercom"
                                                                         v-if="errors.length"/>-->
                                                        </v-col>


                                                        <v-col cols="12" md="8" sm="12" xl="8">
                                                            <v-textarea
                                                                filled
                                                                label="Захтев"
                                                                name="input-7-4"
                                                                placeholder="Унесите опис захтева"
                                                                v-model="order.message"
                                                                :rules="[requiredRule]"
                                                                required

                                                            ></v-textarea>
<!--                                                            <error-field :errors="errors" field="message"
                                                                         v-if="errors.length"/>-->
                                                        </v-col>

                                                    </v-row>
                                                    <v-card-actions>
                                                        <v-spacer></v-spacer>
                                                        <v-btn type="submit" color="primary" :disabled="!valid">
                                                            Пошаљи
                                                        </v-btn>
                                                    </v-card-actions>
                                                </v-card-text>

                                                </v-form>

                                            </v-card>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </div>
                    </v-flex>
                </v-row>
            </v-container>
        </section>
        <section class="contact-section" id="footer">
            <v-container>
                <v-row class="text-center" no-gutters>

                    <v-col class="center justify-center d-flex flex-column align-center pa-5" cols="12" md="4" sm="12"
                           xl="4">
                        <h1>ГРАД БЕОГРАД</h1>
                        <h2>Хвала вам на подршци!</h2>
                        <a href="mailto:ostanikodkuce@beograd.gov.rs"><h3>Контакт: ostanikodkuce@beograd.gov.rs</h3></a>
                        <h3>Београдски позивни центар:<br> 0800 11 00 11 или 011/30 90 007</h3>
                    </v-col>
                    <v-col class="d-flex logos" cols="12" md="8" sm="12" xl="8">
                        <div class="d-flex align-center">
                            <v-img class="footer-logo" src="../../assets/firme/bg-logo.png"></v-img>
                        </div>
                        <div class="d-flex align-center">
                            <v-card class="pa-7">
                                <v-img class="footer-logo mb-0" src="../../assets/firme/infostan-logo.png"></v-img>
                            </v-card>
                        </div>
                    </v-col>
                </v-row>
            </v-container>
        </section>

    </v-content>
</template>

<script>
  import axios from 'axios'

  export default {
    name: 'Landing',
    data: () => ({
      showRequst: false,
      municipalities: [],
      municipalitiesSelected: null,
      displaySuccessText: false,
      errors: [],
      order: {
        message: '',
        requesterFirstName: '',
        requesterLastName: '',
        requesterPhoneNumber: '',
        requesterAddress: '',
        requesterHouseNumber: '',
        requesterAppartmentNumber: '',
        municipalityId: null,
        intercom: '',
        cityId: 1,
        status: 'pending',
      },
      phoneNumbers: null,
      step: 1,
      requiredRule: v => !!v || 'Ово поље је неопходно',
/*      phoneRule: v => /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/.test(v) || 'Лош број телефона',*/
      valid: true,
    otherNumbers: null,
    }),
    watch: {
      municipalitiesSelected () {
        this.step = 2
        for (let item of this.municipalities) {
          if (item.id == this.municipalitiesSelected) {
            this.phoneNumbers = item.phones
            this.order.municipalityId = item.id
            this.otherNumbers = item.otherPhones
          }
        }
      }
    },
    methods: {
      popuniZahtev () {
        this.showRequst = !this.showRequst
        this.step = 3
      },
      getAddressData: function (addressData) {
        this.order.city = addressData.locality
        this.order.requesterAddress = addressData.name
        this.order.lat = addressData.latitude
        this.order.long = addressData.longitude
      },
      async makeNewRequest () {
        await this.$refs.form.validate()
        if(this.valid) {
            let data = { ...this.order }
			const token = await this.$recaptcha('homepage')
            data.recaptcha = token
            axios.post('/orders', data)
            .then(() => {
              this.displaySuccessText = true
              this.$swal({
                title: 'Захтев успешно послат!',
                type: 'success'
              })
              this.$refs.form.reset()
              this.$refs.form.resetValidation()
              this.scrollTo(0)
              this.errors = []
            })
            .catch(err => {
              this.$toasted.global.resp_err({ message: err.response.data.message })
              this.errors = err.response.data.errors ? err.response.data.errors : []
            })
        }
      },
      getMunicipalities: async function () {
        let response = await axios.get('/municipalities')
        this.municipalities = this.lodash.orderBy(response.data, ['name'], ['asc']);
      }
    },
    async mounted () {
        await this.$recaptchaLoaded()
        const recaptchaInstance = this.$recaptchaInstance
        recaptchaInstance.hideBadge()
        this.getMunicipalities()
    }

  }
</script>
<style scoped>
    .about-section {
        background: #0d4077;
        color: white;
    }

    .about-section .row.text-center.no-gutters {
        padding: 97px 0;
    }

    h1 {
        padding: 57px 0;
        font-size: 56px;
        font-weight: 700;
        line-height: 1;
    }

    .about-section h2 {
        font-size: 40px;
        font-weight: 500;
        color: white;
        line-height: 1.2;
        letter-spacing: -.72px;
        margin-bottom: 20px;
    }
        .contact-section a{
        color: white!important;
        line-height: 1.2;
        letter-spacing: -.72px;
    }


    .about-section .flex.xs6.sm6.md-6 {
        padding-bottom: 97px;
    }

    .idea-section {
        color: black;
        background: white;
    }

    .everyone-section {
        background: #eef3f6;
    }

    .contact-section {
        background: #0d4077;
        color: white;
    }

    .contact-section .row.text-center.no-gutters,
    .idea-section .row.text-center.no-gutters,
    .everyone-section .row.no-gutters {
        padding-top: 67px;
        padding-bottom: 67px;
    }

    .idea-text {
        margin: 0 auto;
    }

    ul {
        list-style-type: none;
    }

    ul li {
        font-size: 25px;
    }

    .phone-number {
        font-size: 22px;
    }
    .first-step{
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }
    @media only screen and (max-width: 768px) {

    /* .number-other-phones{
        display: flex;
        flex-direction: column;
    }
    .number-other-phones span.pl-3{
        padding: 12px;
    } */
        h1 {
            font-size: 25px;
        }

        h2 {
            font-size: 18px !important;
            font-weight: 400;
        }

        .logos {
            justify-content: center;
            flex-direction: column;
            align-items: center;
        }

        .footer-logo:first-of-type {
            margin-bottom: 25px;
        }
    }
    @media only screen and (min-width: 768px) and (max-width: 1590px) {

    }

    .logos {
        justify-content: space-around;

    }

    .primarna {
        color: #c7363d;
    }

    .numberCircle {
        display: inline-block;
        color: #c7363d;
        border-radius: 50%;
        border: 2px solid;
        font-size: 32px;
        margin-right: 10px;
    }

    .numberCircle:before,
    .numberCircle:after {
        content: '\200B';
        display: inline-block;
        line-height: 0px;
        padding-top: 50%;
        padding-bottom: 50%;
    }

    .numberCircle:before {
        padding-left: 8px;
    }

    .numberCircle:after {
        padding-right: 8px;
    }

    .underline {
        text-decoration: underline;
    }

    .step-txt {
        font-size: 35px;
    }

    .footer-logo {
        max-width: 170px;
    }

    .footer-logo:last-of-type {
        max-width: 270px;
    }

    .text-help {
        position: relative;
    }

    .text-help:after {
        content: "";
        position: absolute;
        left: 0;
        bottom: 0;
        height: 30%;
        width: 100%;
        background-color: #c7363d;;
        opacity: .2;
    }

    .v-card__title.headline {
        word-break: break-word;
    }
    .other-phones{
        display: flex;
        justify-content: center;
        align-items: center;
    }
</style>
